export * from './VideoPlayer';
export { default } from './VideoPlayer';
